import { render, staticRenderFns } from "./BurgerMenuIcon.vue?vue&type=template&id=0ce29847&scoped=true&"
import script from "./BurgerMenuIcon.vue?vue&type=script&lang=js&"
export * from "./BurgerMenuIcon.vue?vue&type=script&lang=js&"
import style0 from "./BurgerMenuIcon.vue?vue&type=style&index=0&id=0ce29847&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce29847",
  null
  
)

export default component.exports